<template>

	<div class="report_container full" v-loading="loading">
		<vxe-grid class="" v-bind="gridOptions" :key="gridKey" v-if="gridOptions"
			@toolbar-button-click="toolbarButtonClickEvent" :ref="reportName+'_list'">
		</vxe-grid>
		<exportTable :ref="exportRef" :forms="forms" :tableColumn="tableColumn" :reportName="reportName"
			:windowName="windowName" :afterexport="afterexport" listType="report" />
		<formwindow :formConfig="formModule" v-if="formwindowShow" @back="formBack" />
		
		<statistics-index ref="statistics" :bizDate="bizDate" :title="statisticsTitle" />	
	</div>

</template>
<style>

</style>
<style scoped>

</style>
<script>
	import reportBase from '@_system/components/base/report.js'
	import exportMixins from '@_system/components/base/mixins/list/export.js'
	import exportTable from '@_system/components/export/index.vue'
	import statisticsIndex from './lib/statistics/index.vue'
	export default {
		mixins: [reportBase, exportMixins],
		name: 'report',
		props: {

		},
		data() {
			return {
				footerField: [{
					type: 'seq',
					field: 'code',
					title: '汇总',
				}, {
					type: 'field',
					field: 'num',
					toFixed: 0
				}, {
					type: 'field',
					field: 'amount',
					toFixed: 4
				}],
				showFooter: false,
				reportName: 'compensationtrade',
				windowName: '赔付分析',
				pagerConfig: {
					enabled: true,
				},
				loading: false,
				device: window.systemMethods.device(),
				bizDate:null,
				statisticsTitle:'赔付统计'
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {


		},
		computed: {

		},

		methods: {
			// exportdetail() {
			// 	let info = this.$refs[this.reportName + '_list'].getProxyInfo()
			// 	let create_time = info.form.create_time ? info.form.create_time.join(',') : null
			// 	this.$api.compensationtrade.exportdetail({
			// 		create_time: create_time
			// 	}).then((res) => {
			// 		let data = []
			// 		let columns = [{
			// 			field: 'exchange_no',
			// 			title: '售后单编码',
			// 			visible: true,
			// 		}, {
			// 			field: 'trade_no',
			// 			title: '订单编码',
			// 			visible: true,
			// 		}, {
			// 			field: 'packer',
			// 			title: '打包员',
			// 			visible: true,
			// 		}, {
			// 			field: 'shop_nick',
			// 			title: '店铺名称',
			// 			visible: true,
			// 		}, {
			// 			field: 'reason_name',
			// 			title: '错误原因',
			// 			visible: true,
			// 		}, {
			// 			field: 'originalStorage',
			// 			title: '仓库',
			// 			visible: true,
			// 		}]
			// 		res.forEach((item) => {
			// 			data.push({
			// 				exchange_no: item.exchange_no,
			// 				shop_nick: item.shop_nick,
			// 				trade_no: item.trade_no,
			// 				packer: item.packer,
			// 				reason_name: item.reason_name,
			// 				originalStorage: item.originalStorage

			// 			})
			// 		})


			// 		this.$refs[this.exportRef].exportData({
			// 			data: data,
			// 			columns: columns
			// 		})
			// 		console.log(res)
			// 	})
			// },
			statistics() {
				let form = this.$refs[this.reportName + '_list'].getProxyInfo().form
				this.bizDate = form.bizDate
				if(this.bizDate){
					this.statisticsTitle = '赔付统计：' + this.$systemMethods.timestampToDate(form.bizDate[0],true)+' 至 '+this.$systemMethods.timestampToDate(form.bizDate[1],true)
					
				}else{
					this.statisticsTitle = '赔付统计：本月'
				}
				this.$refs.statistics.modalShow()
			},
		},
		components: {
			exportTable,
			statisticsIndex
		}
	}
</script>